module.exports = __webpack_public_path__ + "img/menu-off_04.75373392.png";